__turbopack_context__.v({
  "container": "m0WBFW_container",
  "slide-up": "m0WBFW_slide-up",
});
